import { Map as ImmutableMap } from 'immutable';
import { DateTime } from 'luxon';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authActions, authSelectors } from 'app-components/flux/auth';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { getSessionStartedAt } from 'data/app/selectors';

import { DIALOG_TYPE as DIALOG_CONFIRMATION, mkConfirmationDialogProps } from 'components/Dialogs/ConfirmationDialog';

// Validate our access-token, do  we have one and is it valid. A valid access token is one which
// isn't expired or the refresh token isn't expired. If not valid, then logout user.
//
const useAuthTokenValidator = (props) => {
  const { authNotNeeded } = props;
  const dispatch = useDispatch();

  const { accessToken } = useSelector(authSelectors.getAuthSession);
  const isAuthTokenValid = useSelector(authSelectors.isAuthTokenValid);
  const sessionStartedAt = useSelector(getSessionStartedAt);

  useEffect(() => {
    if (!authNotNeeded && accessToken && !isAuthTokenValid) {
      const sessionStarted = DateTime.fromISO(sessionStartedAt);
      if (sessionStarted.diffNow('minutes').minutes < -1) {
        // app used for a while - not a new session
        dispatch(
          rootUiActions.createDialog(
            rootUiTypes.mkRootUiData({
              id: 'TOKENS_EXPIRED',
              type: DIALOG_CONFIRMATION,
              allowNesting: true,
              props: ImmutableMap(
                mkConfirmationDialogProps({
                  title: 'Session expired',
                  content: (
                    <DialogContent>
                      <Typography variant='titleMedium'>
                        You have been logged out. You need to sign in to continue.
                      </Typography>
                    </DialogContent>
                  ),
                  confirmLabel: 'Sign in',
                  confirmAction: () => {
                    dispatch(authActions.authLogin(undefined, { context: 'user choose to re-auth' }));
                  },
                  denyLabel: 'Keep me logged out',
                  denyAction: () => {
                    dispatch(
                      authActions.authLogout(
                        { reason: 'AUTH_LOGOUT_EXPIRED' },
                        { context: 'auth dialog: logout manually' },
                      ),
                    );
                  },
                }),
              ),
            }),
          ),
        );
      } else {
        // logout automatically
        dispatch(
          authActions.authLogout({ reason: 'AUTH_LOGOUT_EXPIRED' }, { context: 'auth dialog: logout automatically' }),
        );
      }
    }
  }, [accessToken, authNotNeeded, isAuthTokenValid, sessionStartedAt, dispatch]);
};

export default useAuthTokenValidator;
